import BrokenImageFallback from '@/app/images/blaze-icons/broken-image-fallback-gr.svg'
import IDCard from '@/app/images/blaze-icons/id-card.png'
import ImagePlaceholder from '@/app/images/blaze-icons/img-placeholder.svg'
import LogoutArrow from '@/app/images/blaze-icons/logout_arrow.svg'
import UserLogo from '@/app/images/blaze-icons/user.png'

export class CustomIcons {
  static readonly brokenImageFallback = BrokenImageFallback
  static readonly idCard = IDCard
  static readonly imagePlaceholder = ImagePlaceholder
  static readonly logoutArrow = LogoutArrow
  static readonly userLogo = UserLogo

  private constructor() {}
}
